module.exports = __webpack_public_path__ + "static/img/1111.85cd801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/1111.jpg
// module id = Tfkq
// module chunks = 1